import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { inputBoxStyles } from "../InputBox/input.style";
import ErrorLabel from "../ErrorLabel";
import { WarningOutlineIcon } from "../../packages/SVGs";
import { ValueStrings } from "../../utils/constantsString";
import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";
import WPInputLabel from "../../packages/WPInputLabel";

import "./index.scss";

const DupontDatePicker = React.forwardRef(
  (
    {
      id,
      label,
      infolabel,
      labelClass,
      className,
      disabled,
      minDate,
      maxDate,
      error,
      isRequired,
      dateFormat,
      placeholderText,
      showTimeSelect = false,
      portalId = "dupont-datepicker-portal",
      popperPlacement = "bottom-start",
      popperClassName = "dupont-datepicker-popper",
      ...props
    },
    ref,
  ) => {
    const classes = inputBoxStyles();

    const handleRawChange = (event) => {
      event.preventDefault();
    };

    const handleKeyDown = (event) => {
      if (event.key !== "Tab") {
        event.preventDefault();
      }
    };

    const handlePaste = (event) => {
      event.preventDefault();
    };

    return (
      <div>
        {label && (
          <div className="info-section">
            <WPInputLabel label={label} required={isRequired} className={labelClass} />
            {infolabel && <IconWithTooltip label={infolabel} />}
          </div>
        )}
        <DatePicker
          {...props}
          id={id}
          disabled={disabled}
          className={`${classes.textfield} custom-input ${className}`}
          minDate={minDate}
          maxDate={
            maxDate || new Date().setFullYear(new Date().getFullYear() + 1)
          }
          minTime={props.minTime || new Date(new Date().setHours(0, 0, 0, 0))}
          maxTime={
            props.maxTime || new Date(new Date().setHours(23, 59, 59, 999))
          }
          onChangeRaw={handleRawChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          showTimeSelect={showTimeSelect}
          dateFormat={dateFormat || ValueStrings.DATE_FORMAT_SMALL}
          placeholderText={placeholderText || ValueStrings.dateFormat}
          shouldCloseOnSelect={false}
          portalId={portalId}
          popperPlacement={popperPlacement}
          popperClassName={popperClassName}
        />

        <div className="errorText">
          {error && (
            <>
              <WarningOutlineIcon isError />
              <ErrorLabel className="text-left " message={error} />
            </>
          )}
        </div>
      </div>
    );
  },
);

export default DupontDatePicker;
